import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@/components/shared/PageLoader';

const Contacts = lazy(() => import('@/pages/Contacts'));

export const Route = createFileRoute('/crm/contacts')({
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <Contacts />
    </Suspense>
  ),
});
